import React, { useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { Button, Stack } from '@mui/material'
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh }) => {
  console.log(data, 'datadata')
  const AppService = useAppServices()
  const uploadImage = useUploadImage()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [svgIcon, setSvgIcon] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const [description, setDescription] = useState(data.award_description)

  const handleModal = () => {
    setOpenEditProduct(true)
  }

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0])
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0])
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    let image_response = null
    if (selectedFile) {
      image_response = await uploadImage({
        file: selectedFile,
        desiredPath: `app/logo/image`,
      })
    }

    const payload = {
      name: e.target.name.value,
      award_name: e.target.award_name.value,
      award_description: description,
      points: Number(e.target.points.value),
      priority: e.target.priority.value,
      type: e.target.type.value,
      status: e.target.status.value,
      image: image_response?.response.data || data?.image || '',
    }

    console.log(payload, 'payload')

    const { response } = await AppService.award_list.update({
      query: `id=${data._id}`,
      payload,
    })

    if (response) {
      setProcessing(false)
      // closeAddProduct();
      setOpenEditProduct(false)

      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Section
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">award name</MDTypography>
              <MDInput
                label="award name"
                name="award_name"
                fullWidth
                required
                defaultValue={data.award_name}
              />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">award description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Point Number</MDTypography>
              <MDInput label="Point Number" name="points" fullWidth defaultValue={data.points} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Priority</MDTypography>
              <MDInput label="Priority" name="priority" fullWidth defaultValue={data.priority} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                defaultValue={data.type}
                SelectProps={{ native: true }}
              >
                <option value="Agency">Agency</option>
                <option value="Location">Location</option>
                <option value="User">User</option>
                <option value="appcreator">Appcreator</option>
              </MDInput>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput select name="status" fullWidth required SelectProps={{ native: true }}
              defaultValue={data.status}
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" onChange={handleFileChange} />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
